import type { FormErrors } from 'pages/licenses/combo_license/components/ComboLicenseForm';
import { LicenseFormPayload } from 'apis/LicenseApi';

export const validateLicenseForm = (payload: LicenseFormPayload): FormErrors => {

    const errors: FormErrors = {};
    if (!payload.name.trim()) errors.name = 'Name is required.';
    if (!payload.licenseDuration || payload.licenseDuration <= 0)
        errors.licenseDuration = 'Duration must be greater than 0.';
    if (!payload.usageDays || payload.usageDays <= 0)
        errors.usageDays = 'Student usage days must be greater than 0.';
    return errors;

};